export * from './lib/form-file-upload.module';

export * from './lib/interfaces/file-upload-form-field-config.interface';
export * from './lib/interfaces/file-upload-template-options.interface';
